/*
 * @Author: 朴子跃
 * @Date: 2025-07-25
 * @Desc: 迁移工具store
 */
import { defineStore } from 'pinia';
import _ from 'lodash';
import { Message } from '@arco-design/web-vue';
import { migrationToolsService } from '@/api';
// TAG: 迁移工具
export const useMigrationToolsStore = defineStore('migrationTools', {
  state: () => ({
    isTableLoading: false,
    // 表格数据
    tableData: [],
    modules: [],
    migrationStatus: {},
    // 租户id
    tenantId: ''
  }),
  getters: {
    // 导出
    exportTableData: (state) => groupByModule(state.tableData),
    // 导入-第一部分
    importTableData1: (state) => groupByModule((state.tableData || []).filter((item) => item.part === 1)),
    // 导入-第三部分
    importTableData3: (state) => groupByModule((state.tableData || []).filter((item) => item.part === 3))
  },
  actions: {
    setTenantId(tenantId) {
      this.tenantId = tenantId;
    },
    // get data
    getDataTaskList(params) {
      this.isTableLoading = true;
      migrationToolsService
        .getDataTaskList(params)
        .then((res) => {
          if (res.result) {
            this.tableData = res.result;
          } else {
            Message.error(res.error?.msg || '获取数据失败');
          }
        })
        .finally(() => {
          this.isTableLoading = false;
        });
    },
    async getModules() {
      const res = await migrationToolsService.getSupportModules({
        tenantId: this.tenantId
      });
      if (!res?.error) {
        this.modules = res?.result || [];
      } else {
        Message.error(res.error?.msg || '获取数据失败');
      }
    },
    getMigrationStatus(params) {
      migrationToolsService.getTenantStatus(params).then((res) => {
        this.migrationStatus = res.result;
      });
    }
  }
});
// tableData 按moduleName分组
const groupByModule = (data) => {
  return Object.entries(_.groupBy(data, 'moduleName')).map(([moduleName, children], index) => ({
    dataType: index,
    type: 'module',
    moduleName,
    children
  }));
};
export default useMigrationToolsStore;
